import { render, staticRenderFns } from "./TopicValue.vue?vue&type=template&id=f2c9507e&scoped=true"
import script from "./TopicValue.vue?vue&type=script&lang=js"
export * from "./TopicValue.vue?vue&type=script&lang=js"
import style0 from "./TopicValue.vue?vue&type=style&index=0&id=f2c9507e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c9507e",
  null
  
)

export default component.exports